var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00158 5.90777C4.83529 5.9081 4.67412 5.85018 4.54607 5.74408L0.27567 2.1854C0.130322 2.0646 0.0389183 1.891 0.0215664 1.70279C0.00421451 1.51459 0.0623361 1.32721 0.183145 1.18186C0.303954 1.03651 0.477554 0.945107 0.665755 0.927755C0.853956 0.910403 1.04134 0.968525 1.18669 1.08933L5.00158 4.2779L8.81648 1.20321C8.88928 1.14409 8.97305 1.09994 9.06297 1.0733C9.15289 1.04666 9.24719 1.03805 9.34045 1.04797C9.4337 1.05789 9.52408 1.08615 9.60638 1.13111C9.68869 1.17607 9.76129 1.23686 9.82003 1.30997C9.88521 1.38315 9.93457 1.46901 9.96503 1.56215C9.99548 1.6553 10.0064 1.75373 9.99702 1.85129C9.98767 1.94884 9.95827 2.04341 9.91067 2.12907C9.86306 2.21473 9.79828 2.28964 9.72038 2.3491L5.44998 5.78678C5.31825 5.87611 5.16037 5.91871 5.00158 5.90777Z",
    fill: "#676C77"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.22c46685.svg";
export { ForwardRef as ReactComponent };